import React from 'react';
import { FaSpinner } from 'react-icons/fa';

function SplashScreen() {
  return (
    <div className='flex flex-col items-center justify-center w-screen h-screen bg-customeBlack'>
        <img className='self-center h-64' src={require('../../images/logo.gif')} alt='Minerva Analytics' />
        <FaSpinner className='animate-spin text-gray-500 mt-4' size={30} />
    </div>
  )
}

export default SplashScreen